import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, take } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { canAccessCapIQProDuringImpersonation } from '@capital-access/common/user';
import { CIQPRO_FEATURE_TOGGLE } from './constants';

@Injectable()
export class CanAccessCiqProGuard {
  constructor(private router: Router, private store: Store) {}

  canActivate() {
    return combineLatest([
      this.store.select(getFeatureToggle(CIQPRO_FEATURE_TOGGLE)),
      this.store.select(canAccessCapIQProDuringImpersonation)
    ]).pipe(
      map(([isEnabled, canAccessCapIQProDuringImpersonation]) => {
        const canAccess = isEnabled && canAccessCapIQProDuringImpersonation;
        if (!canAccess) this.router.navigate(['/']);
        return canAccess;
      }),
      take(1)
    );
  }

  canActivateChild() {
    return this.canActivate();
  }
}
